"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormSignalMappingComparison = exports.FormSignalMappingRowSchema = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const z = require("zod");
const value_comparison_1 = require("../../Comparison/value-comparison");
const signal_name_normalization_1 = require("../../DataScience/signal-hygiene/signal-name-normalization");
const comparison_spec_1 = require("../comparison-spec");
const pin_id_normalization_1 = require("./pin-id-normalization");
exports.FormSignalMappingRowSchema = z.object({
    modelSignalRef: z.string(),
    blockName: z.string(),
    blockIndex: z.number(),
    signalName: z.string(),
    pins: z.string().array(),
    floatingBehavior: sigma_engine_shared_1.DesignModels.SignalFloatingBehaviorSchema.optional(),
});
class FormSignalMappingComparison extends comparison_spec_1.ComparisonSpec {
    constructor() {
        super(...arguments);
        this.alignment = new comparison_spec_1.CellAlignment(['modelSignalRef', 'blockName', 'blockIndex'], ['signalName', 'pins', 'floatingBehavior']);
    }
    toRows(data) {
        return data;
    }
    fromRows(rows) {
        return rows;
    }
    rowKeyOf(row) {
        return (0, value_comparison_1.compositeKey)(row, this.alignment.keyColumns.map(String), (column, value, rowContext) => this.normalize(column, value, rowContext));
    }
    normalize(column, value, row) {
        if (column === 'signalName' && typeof value === 'string') {
            return (0, signal_name_normalization_1.normalizeSignalNameForComparison)(value);
        }
        if (column === 'pins' && Array.isArray(value)) {
            const canonical = value
                .map((pin) => (typeof pin === 'string' ? (0, pin_id_normalization_1.normalizePinIdForComparison)(pin) : String(pin)))
                .sort();
            return JSON.stringify(canonical);
        }
        return super.normalize(column, value, row);
    }
}
exports.FormSignalMappingComparison = FormSignalMappingComparison;
//# sourceMappingURL=form-signal-mapping.comparison.js.map